module.exports = __webpack_public_path__ + "media/components/src/assets/images/navigate_next/navigate_next_black_24dp-c7812bb28e825fd1af1122738f2e2f7b.svg";